export type VerdictLevel = "good" | "warn" | "bad";

interface VerdictBoxProps {
  level: VerdictLevel;
  title: string;
  detail?: string;
}

const LEVEL_CLASS: Record<VerdictLevel, string> = {
  good: "border-green bg-green-pale text-green",
  warn: "border-amber bg-amber-pale text-amber",
  bad: "border-red bg-red-pale text-red",
};

/** Hukum kutusu — gidisat ozetindeki tek satirlik degerlendirme (iyi/dikkat/kotu). */
export function VerdictBox({ level, title, detail }: VerdictBoxProps) {
  return (
    <div role="status" className={`rounded-lg border p-3 ${LEVEL_CLASS[level]}`}>
      <p className="font-semibold">{title}</p>
      {detail && <p className="mt-0.5 text-sm opacity-80">{detail}</p>}
    </div>
  );
}
